import React from "react";
import { LoginError } from "../../../models/enumerations/login-error";
import { useTranslation } from 'react-i18next';

export interface LoginModalTitleProps {
    error: LoginError,
}

/**
 * Represents the title that is displayed in the login modal when a login error
 * occurs.
 *
 * @param props The properties
 * @returns {JSX.Element} The component
 */
const LoginModalTitle: React.FC<LoginModalTitleProps> = (props) => {
    const { error } = props;
    const { t } = useTranslation();

    const title = (error === LoginError.AdminTrialExpired) || (error === LoginError.TrialExpired)
        ? t('login.modal.trialExpired')
        : t('login.modal.accountDeactivated')
    return (
        <h1 className="block" style={{ padding: '105px 0px 48px 0px', textAlign: 'center' }}>{title}</h1>
    );
};

export default LoginModalTitle;